<!-- ATENCIÓN A COMERCIOS (EJE-02; Mario, 14-oct) -->
<div class="kb-page">
  <nav class="kb-migas" aria-label="Migas">
    <a class="kb-miga" routerLink="/console/parametros-sistema">Parámetros</a><span class="kb-miga-sep">/</span><span class="kb-miga-actual">Atención a comercios</span>
  </nav>
  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title flex items-center gap-2.5"><i class="fas fa-headset text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Atención a comercios</h1>
      <p class="kb-page-meta">Lo que ve en su portal el comercio que no tiene ejecutivo asignado, cuando un aviso le dice «coméntalo a tu ejecutivo».</p>
    </div>
  </div>
  <section class="kb-card">
    <div class="kb-card-body">
      <p class="kb-hint m-0" *ngIf="cargando">Leyendo…</p>
      <form class="grid max-w-xl gap-4" (ngSubmit)="guardar()" *ngIf="!cargando">
        <label class="kb-label">Nombre que ve el comercio<input class="kb-input" name="nombre" [(ngModel)]="f.nombre" placeholder="Atención a comercios"></label>
        <div class="grid gap-4 sm:grid-cols-2">
          <label class="kb-label">Teléfono<input class="kb-input" name="telefono" [(ngModel)]="f.telefono" placeholder="0212-555-1234"></label>
          <label class="kb-label">WhatsApp<input class="kb-input" name="whatsapp" [(ngModel)]="f.whatsapp" placeholder="0414-555-0000"></label>
        </div>
        <label class="kb-label">Correo<input class="kb-input" type="email" name="correo" [(ngModel)]="f.correo" placeholder="comercios@creditotal.online"></label>
        <label class="kb-label">Horario<input class="kb-input" name="horario" [(ngModel)]="f.horario" placeholder="Lunes a viernes, 8:00 a 5:00"></label>
        <div class="kb-aviso kb-aviso-alerta" *ngIf="error" role="alert">{{ error }}</div>
        <div class="kb-aviso kb-aviso-info" *ngIf="ok" role="status">{{ ok }}</div>
        <div><button type="submit" class="kb-btn !w-auto !bg-foreground !text-background" [disabled]="guardando">{{ guardando ? 'Guardando…' : 'Guardar' }}</button></div>
      </form>
    </div>
  </section>
</div>
